import React from 'react';
import { registerClass, currySC, IFNTheme, cns } from '@food/css-manager';
import { Icon } from '@food/ui';
import { hasSubscription, IHasSubscriptionArgs } from '../utils/hasSubscription';

interface ISubscriptionBannerStatusActiveProps {
	className?: any;
	layout?: string;
	user: IHasSubscriptionArgs['user'];
}

const styleClass = registerClass(
	(t: IFNTheme) => `
	margin: 0 0 ${t.ratios.l * t.font.baseSize}px;
	background: #cdd5e2;
	padding: 1em;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: ${t.font.weights.bold};
	text-transform: uppercase;
	line-height: 1;
	font-size: 125%;
	letter-spacing: 0.02em;
	color: #596f96;

	&:first-child {
		margin-top: 0;
	}

	&:hover {
		color: #596f96;
	}

	p {
		padding-top: 0.2em;
		margin-right: 0.7em;
	}
	span {
		font-size: 150%;
	}
`,
);

const sc = currySC(styleClass);

export const SubscriptionBannerStatusActive: React.FunctionComponent<ISubscriptionBannerStatusActiveProps> = ({
	className,
	layout,
	user,
}) => {
	const isSubscribed = hasSubscription({ user: user });
	return (
		<>
			{isSubscribed && (
				<div className={cns(className, styleClass, sc(`layout-${layout}`))}>
					<p>Abbonamento attivo</p>
					<Icon className={sc('icon')} name={'check'} />
				</div>
			)}
		</>
	);
};
